<div
  class="card"
  [ngClass]="{
    'translucent-card': !ownsVehicle && vehicle.sold && !vehicle.ownsCurrentBid,
    'size-grid-mode': gridMode
  }"
>
  <div class="card-body">
    <div [ngClass]="{ 'flex-card-grid': gridMode, 'flex-card-list': !gridMode }">
      <div
        class="tag-container"
        *ngIf="vehicle.ownsCurrentBid || ownsVehicle || vehicle.sold || vehicle.status === 'DELETED'"
        [ngClass]="{
          'fast-quote': vehicle.status == 'FAST_QUOTE',
          deleted: vehicle.status == 'DELETED',
          'conditional-offer': vehicle.inactive && vehicle.hasConditionalOfferPending,
          inactive: vehicle.inactive && !vehicle.hasConditionalOfferPending,
          active: vehicle.active || vehicle.waitingPublication,
          sold: vehicle.sold && (ownsVehicle || vehicle.ownsCurrentBid),
          'not-sold-to-me': vehicle.sold && !ownsVehicle && !vehicle.ownsCurrentBid
        }"
      >
        <ng-container *ngIf="vehicle.status === 'FAST_QUOTE' && ownsVehicle"><i class="app-icon-fast-lightning"></i>COTAÇÃO RÁPIDA </ng-container>
        <ng-container *ngIf="vehicle.inactive && !vehicle.hasConditionalOfferPending"><i class="app-icon-config-alt"></i>NÃO PUBLICADO</ng-container>
        <ng-container *ngIf="vehicle.active && vehicle.dealType !== 'FAST_QUOTE'"><i class="app-icon-tag"></i>EM ANDAMENTO</ng-container>
        <ng-container *ngIf="vehicle.waitingPublication"><i class="app-icon-tag"></i>AGUARDANDO PUBLICAÇÃO</ng-container>
        <ng-container *ngIf="vehicle.sold"><i class="app-icon-hammer"></i>ARREMATADO</ng-container>
        <ng-container *ngIf="vehicle.inactive && vehicle.hasConditionalOfferPending"><i class="material-icons">hourglass_full</i>OFERTA PENDENTE</ng-container>
        <ng-container *ngIf="vehicle.status === 'DELETED'"><i class="material-icons">delete_outline</i>EXCLUÍDO </ng-container>
      </div>
      <div class="tag-container fast-quote" *ngIf="(vehicle.isFastQuote || vehicle.dealType === 'FAST_QUOTE') && !ownsVehicle">
        <ng-container><i class="app-icon-fast-lightning"></i>COTAÇÃO RÁPIDA </ng-container>
      </div>

      <div class="vehicle-img-container">
        <div class="next-img" (click)="nextImg(vehicle)" *ngIf="imgUrls && imgUrls.length > 1">
          <i class="fa-solid fa-chevron-circle-right"></i>
        </div>
        <div class="prev-img" (click)="prevImg(vehicle)" *ngIf="imgUrls && imgUrls.length > 1">
          <i class="fa-solid fa-chevron-circle-left"></i>
        </div>
        <a (click)="emitClick()" [routerLink]="[baseUrlDir, slug, vehicle.id]" [ngClass]="{ 'no-img': !imgUrls || imgUrls.length <= 0 }" target="_blank">
          <app-fipe-comparison-badge
            *ngIf="vehicle.fipeDiff !== undefined"
            variant="overlay"
            [fipeDiff]="vehicle.fipeDiff"
            [displayMode]="FipeComparisonMode.DIFFERENCE"
            [hideIfAboveFipe]="true"
          />
          <div class="has-video-container" *ngIf="vehicle.hasVideo">
            <i class="fa-solid fa-video"></i>
          </div>

          <img *ngIf="vehicle.isArmored" class="armored-logo" src="assets/images/icons/blindado-logo.svg" alt="">

          <div class="new-car" *ngIf="vehicle.isNew && !ownsVehicle && vehicle.dealType !== 'FAST_QUOTE'">Novidade</div>

          <div class="tag-container showroom" *ngIf="vehicle.destination === 'SHOWROOM'"><i class="app-icon-showroom"></i>SHOWROOM</div>
          <div class="card-gallery" *ngIf="imgUrls && imgUrls.length > 0">
            <img class="rounded card-image" src="{{ img }}" [ngClass]="{ show: imgIndex == i }" *ngFor="let img of vehicleImages; let i = index" />
          </div>
          <div noImg class="no-img" *ngIf="!imgUrls || imgUrls.length <= 0">
            <i class="material-icons">photo_library</i>
          </div>
        </a>
      </div>
      <div class="vehicle-info">
        <a (click)="emitClick()" [routerLink]="[baseUrlDir, slug, vehicle.id]" target="_blank">
          <div class="row">
            <div class="col-md-12">
              <h1 class="name">
                {{ vehicle.make }} {{ vehicle.model }}
                <ng-container *ngIf="gridMode"><br /></ng-container>
                <i
                  class="fav-icon ml-2"
                  (click)="toggleFavorite($event)"
                  *ngIf="!ownsVehicle && user?.hasRole('DEALER')"
                  [ngClass]="{
                    'app-icon-love': !vehicle.favorite,
                    'app-icon-love-alt': vehicle.favorite
                  }"
                ></i>
              </h1>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-md-12">
              <div class="years">{{ vehicle.manufactureYear }}/{{ vehicle.modelYear }}</div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="description">
                {{ vehicle.trim }}
              </div>
            </div>
          </div>
        </a>

        <div class="infos">
          <span *ngIf="vehicle.km != null">
            <i class="material-icons">maps</i>
            {{ vehicle.km | number }} km
          </span>
          <span *ngIf="vehicle.transmission !== undefined">
            <i class="material-icons">airline_seat_recline_normal</i>
            {{ transmission }}
          </span>
          <span *ngIf="vehicle.fuel !== undefined">
            <i class="material-icons">local_gas_station</i>
            {{ fuel }}
          </span>
          <div>
            <span *ngIf="vehicle.numberPlate !== undefined">
              <i class="material-icons">label</i>
              {{ vehicle.numberPlate }}
            </span>
            <span *ngIf="vehicle.reportStatus"
              ><i class="material-icons">playlist_add_check</i>
              {{ reportStatus }}
            </span>
          </div>
          <!--  <span *ngIf="vehicle.extraKey !== undefined"><i class="material-icons">vpn_key</i>
            {{
            vehicle.extraKey ? "Com chave reserva" : "Sem chave reserva"
            }}</span>
          <span *ngIf="vehicle.carManual !== undefined"><i class="material-icons">file_copy</i>
            {{ vehicle.carManual ? "Com manual" : "Sem manual" }}</span>
          <span><i class="material-icons">room</i> {{ vehicle.city }} /
              {{ vehicle.uf }}
          </span> -->
        </div>

        <!-- CARD WHEN IS FAST QUOTE-->
        <div class="row" *ngIf="vehicle.isFastQuote && !vehicle.sold">
          <div class="col-12">
            <a
              class="bid-info"
              [routerLink]="[baseUrlDir, slug, vehicle.id]"
              target="_blank"
              [ngClass]="{
                'row-cast-off-danger': vehicle.ownsAnyBid && (vehicle.highestBid != vehicle.bidValue || !vehicle.ownsCurrentBid) && !vehicle.sold,
                'row-cast-off-current-bidder': vehicle.ownsAnyBid && (vehicle.highestBid == vehicle.bidValue || vehicle.ownsCurrentBid) && !vehicle.sold,
                'row-cast-off-sold-another-person': vehicle.sold && !vehicle.ownsCurrentBid,
                'flex-column': gridMode
              }"
            >
              <div [ngClass]="{ 'margin-y-4': gridMode }">
                <div class="title">
                  <ng-container *ngIf="vehicle.ownsAnyBid && (vehicle.highestBid != vehicle.bidValue || !vehicle.ownsCurrentBid) && !vehicle.sold">
                    <i class="app-icon-tag"></i> COBRIRAM A SUA OFERTA
                  </ng-container>
                  <ng-container *ngIf="vehicle.ownsAnyBid && (vehicle.highestBid == vehicle.bidValue || vehicle.ownsCurrentBid)">
                    <i class="app-icon-tag"></i> SUA ÚLTIMA OFERTA
                  </ng-container>
                  <ng-container *ngIf="vehicle.sold"> <i class="app-icon-hammer"></i> OUTRA REVENDA ARREMATOU POR </ng-container>
                </div>
                <div
                  class="timer-content d-flex align-items-center"
                  [ngClass]="{
                    'justify-content-between': vehicle.highestBid || vehicle.currentPrice,
                    'justify-content-end': !vehicle.highestBid && !vehicle.currentPrice
                  }"
                >
                  <div class="value" *ngIf="vehicle.highestBid || vehicle.currentPrice">
                    <span class="symbol">R$</span>
                    {{ vehicle.highestBid || vehicle.currentPrice | number : "1.0-0" }}
                  </div>

                  <div class="d-flex" style="align-items: flex-end" *ngIf="!vehicle.sold && vehicle.active && !isDanger && !isCurrentBid && (user != undefined)">
                    <div class="base-timer">
                      <svg class="base-timer__svg" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                        <g class="base-timer__circle">
                          <circle class="base-timer__path-elapsed" cx="60" cy="60" r="50"></circle>
                          <path
                            class="base-timer__path-remaining"
                            [attr.stroke-dasharray]="contador?.circleDasharray"
                            [ngClass]="{ green: !contador?.danger, red: contador?.danger }"
                            d="
                              M 60, 60
                              m -50, 0
                              a 50,50 0 1,0 100,0
                              a 50,50 0 1,0 -100,0
                            "
                          ></path>
                        </g>
                      </svg>
                    </div>
                    <div class="time" [ngClass]="{ 'time-danger': contador?.danger }">
                      <i class="material-icons">timer</i>
                      {{ contador?.days }}d {{ contador?.hours | number : "2.0-0" }}h {{ contador?.minutes | number : "2.0-0" }}m
                      {{ contador?.seconds | number : "2.0-0" }}s
                    </div>
                  </div>
                </div>
                <div class="infos" *ngIf="vehicle.currentBidDealerName && !vehicle.ownsCurrentBid && user?.hasPermissionMenuVender()">Oferta de: {{ vehicle.currentBidDealerName }}</div>
              </div>
              <div class="buttons-container" [ngClass]="{ 'grid-buttons-container margin-y-4': gridMode }">
                <ng-container *ngIf="vehicle.ownsAnyBid && (vehicle.highestBid == vehicle.bidValue || vehicle.ownsCurrentBid)">
                  <i class="material-icons">check_circle</i> Maior oferta até agora!
                </ng-container>
                <ng-container
                  *ngIf="vehicle.ownsAnyBid && vehicle.bidValue && (vehicle.highestBid != vehicle.bidValue || !vehicle.ownsCurrentBid) && !vehicle.sold"
                >
                  Sua oferta: R${{ vehicle.bidValue | number : "1.2-2" }}
                </ng-container>
                <ng-container *ngIf="!vehicle.ownsAnyBid && !ownsVehicle && vehicle.active && user && user.isDealer()">
                  <div ngbDropdown placement="bottom-left" #makeBidFastQuoteDropdown="ngbDropdown">
                    <span
                      class="btn btn-primary btn-rounded mr-2"
                      *ngIf="!vehicle.ownsAnyBid"
                      ngbDropdownToggle
                      (click)="makeBidFastQuoteDropdown.open(); $event.stopPropagation(); $event.preventDefault()"
                    >
                      FAÇA SUA OFERTA
                    </span>
                    <div ngbDropdownMenu class="dropdown-menu make-bid-panel" (click)="$event.preventDefault()">
                      <ng-container *ngIf="(vehicle.target == 'EXCLUSIVE_GROUPS' && vehicle.exclusiveDealer == true) || vehicle.target != 'EXCLUSIVE_GROUPS'">
                        <app-make-bid-fast-quote
                          (click)="$event.preventDefault()"
                          [vehicle]="vehicle"
                          [disableConfirmationModal]="true"
                          [fromCard]="true"
                        ></app-make-bid-fast-quote>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
              </div>
            </a>
          </div>
        </div>

        <!-- CARD WHEN IS VEHICLE IDX-->
        <div class="row" *ngIf="(!vehicle.isFastQuote || vehicle.sold) && !(hideSoldPurchaseInfo && vehicle.sold)">
          <div class="col-12">
            <a
              class="bid-info"
              [routerLink]="[baseUrlDir, slug, vehicle.id]"
              target="_blank"
              [ngClass]="{
                'row-cast-off-danger': isDanger,
                'row-cast-off-comission-paid': vehicle.sold && vehicle.comissionPaid,
                'row-cast-off-current-bidder': isCurrentBid,
                'row-cast-off-has-bids': ownsVehicle && vehicle.hasBids && vehicle.active,
                'row-cast-off-has-no-bids':
                  ownsVehicle && !vehicle.hasBids && (vehicle.active || (!vehicle.sold && vehicle.status !== 'DELETED' && vehicle.listPrice)),
                'row-cast-off-sold-another-person': !ownsVehicle && vehicle.sold && !vehicle.ownsCurrentBid,
                'flex-column': gridMode
              }"
            >
              <div [ngClass]="{ 'margin-y-4': gridMode }">
                <div class="title">
                  <ng-container *ngIf="!hasPendingCounterOffer && vehicle.ownsAnyBid && !vehicle.ownsCurrentBid && !ownsVehicle && !vehicle.sold">
                    <i class="app-icon-tag"></i> COBRIRAM A SUA OFERTA
                  </ng-container>
                  <ng-container *ngIf="!hasPendingCounterOffer && vehicle.ownsCurrentBid && vehicle.active && !ownsVehicle"> <i class="app-icon-tag"></i> SUA ÚLTIMA OFERTA </ng-container>
                  <ng-container *ngIf="hasPendingCounterOffer">
                    <div class="d-flex flex-column gap-1">
                      <div class="d-flex align-items-center" style="font-size: 9px;" *ngIf="!vehicle.hasConditionalOfferPending">
                        <i class="app-icon-tag"></i> OFERTA PERSONALIZADA
                      </div>
                      <div class="d-flex align-items-center">
                        <i class="material-icons">sync_alt</i> CONTRA PROPOSTA RECEBIDA
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!hasPendingCounterOffer && !vehicle.hasBids && vehicle.active && !ownsVehicle && vehicle.hasPersonalizedOffer">
                    <i class="app-icon-tag"></i> COM OFERTA PERSONALIZADA
                  </ng-container>
                  <ng-container *ngIf="vehicle.sold && (ownsVehicle || vehicle.ownsCurrentBid) && !hideSoldPurchaseInfo"> <i class="app-icon-hammer"></i> ARREMATADO POR </ng-container>
                  <ng-container *ngIf="ownsVehicle && vehicle.hasBids && vehicle.active"> <i class="app-icon-tag"></i> OFERTA ATUAL </ng-container>
                  <ng-container *ngIf="ownsVehicle && !vehicle.hasBids && vehicle.active"> AGUARDANDO OFERTA INICIAL </ng-container>
                  <ng-container
                    *ngIf="
                      ownsVehicle &&
                      !vehicle.hasBids &&
                      !vehicle.active &&
                      !vehicle.waitingPublication &&
                      !vehicle.sold &&
                      vehicle.status !== 'DELETED' &&
                      vehicle.listPrice
                    "
                  >
                    PREÇO PARA ANÚNCIO
                  </ng-container>
                  <ng-container *ngIf="!ownsVehicle && vehicle.sold && !vehicle.ownsCurrentBid && !hideSoldPurchaseInfo">
                    <i class="app-icon-hammer"></i> OUTRA REVENDA ARREMATOU
                  </ng-container>
                </div>
                <div class="timer-content d-flex justify-content-between align-items-center">
                  <div class="value" *ngIf="valueToDisplay !== undefined && valueToDisplay !== null && !(!ownsVehicle && vehicle.sold && !vehicle.ownsCurrentBid) && !(hideSoldPurchaseInfo && vehicle.sold)">
                    <span class="symbol">R$</span>
                    {{ valueToDisplay | number : "1.0-0" }}
                  </div>
                  <div class="d-flex" style="align-items: flex-end" *ngIf="!vehicle.sold && vehicle.active && !isDanger && !isCurrentBid && (user != undefined)">
                    <div class="base-timer">
                      <svg class="base-timer__svg" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                        <g class="base-timer__circle">
                          <circle class="base-timer__path-elapsed" cx="60" cy="60" r="50"></circle>
                          <path
                            class="base-timer__path-remaining"
                            [attr.stroke-dasharray]="contador?.circleDasharray"
                            [ngClass]="{ green: !contador?.danger, red: contador?.danger }"
                            d="
                              M 60, 60
                              m -50, 0
                              a 50,50 0 1,0 100,0
                              a 50,50 0 1,0 -100,0
                            "
                          ></path>
                        </g>
                      </svg>
                    </div>
                    <div class="time" [ngClass]="{ 'time-danger': contador?.danger }">
                      <i class="material-icons">timer</i>
                      {{ contador?.days }}d {{ contador?.hours | number : "2.0-0" }}h {{ contador?.minutes | number : "2.0-0" }}m
                      {{ contador?.seconds | number : "2.0-0" }}s
                    </div>
                  </div>
                </div>
                <div class="counter-offer-summary" *ngIf="hasPendingCounterOffer">
                  <div class="counter-offer-original" *ngIf="originalProposalValueToDisplay !== undefined && originalProposalValueToDisplay !== null">
                    Sua oferta original: R$ {{ originalProposalValueToDisplay | number : "1.0-0" }}
                  </div>
                </div>
                <div class="dealer-name-info" style="height: 10px" *ngIf="vehicle.currentBidDealerName && !vehicle.ownsCurrentBid && user?.hasPermissionMenuVender() && !(!ownsVehicle && vehicle.sold && !vehicle.ownsCurrentBid)">
                  Oferta de: {{ vehicle.currentBidDealerName }}
                </div>
                <!-- <div *ngIf="vehicle.hasConditionalOfferPending" class="label mt-3">
                  <span>Condicional desde: {{ vehicle.expirationDate | date : "dd/MM/yyyy" }}</span>
                </div> -->
                <ng-container
                  *ngIf="
                    ownsVehicle &&
                    !vehicle.hasBids &&
                    !vehicle.active &&
                    !vehicle.waitingPublication &&
                    !vehicle.sold &&
                    vehicle.status !== 'DELETED' &&
                    vehicle.listPrice
                  "
                >
                  <div class="value">
                    <span class="symbol">R$</span>
                    {{ vehicle.listPrice | number : "1.2-2" }}
                    <div class="symbol" *ngIf="vehicle.listPriceFipeDiff != null">
                      (<app-fipe-comparison-badge
                        variant="inline"
                        [fipeDiff]="vehicle.listPriceFipeDiff"
                        [displayMode]="user?.fipeComparisonMode"
                      />)
                    </div>
                  </div>
                </ng-container>
              </div>
              <div class="buttons-container" [ngClass]="{ 'grid-buttons-container margin-y-4': gridMode }" *ngIf="vehicle.status !== 'DELETED'">
                <ng-container
                  *ngIf="
                    !vehicle.ownsCurrentBid &&
                    !vehicle.hasPersonalizedOffer &&
                    !ownsVehicle &&
                    vehicle.active
                  "
                >
                  <div ngbDropdown placement="bottom-left" #makeBidDropdown="ngbDropdown" *ngIf="vehicle.status === 'ACTIVE' && 
                  user?.hasRole('DEALER') && vehicle.bidOption !== 'ONLY_FINAL_BID' && vehicle.bidOption !== 'NONE'">
                    <span
                      class="makebid-button btn btn-primary btn-rounded ml-1"
                      *ngIf="!vehicle.ownsAnyBid"
                      ngbDropdownToggle
                      (click)="makeBidDropdown.open(); $event.stopPropagation(); $event.preventDefault()"
                    >
                      FAÇA SUA OFERTA
                    </span>
                    <span
                      class="btn btn-primary btn-rounded"
                      *ngIf="vehicle.ownsAnyBid"
                      ngbDropdownToggle
                      (click)="makeBidDropdown.open(); $event.stopPropagation(); $event.preventDefault()"
                    >
                      NOVA OFERTA
                    </span>
                    <div ngbDropdownMenu class="dropdown-menu make-bid-panel">
                      <ng-container *ngIf="(vehicle.target == 'EXCLUSIVE_GROUPS' && vehicle.exclusiveDealer == true) || vehicle.target != 'EXCLUSIVE_GROUPS'">
                        <app-make-bid [vehicle]="vehicle" [disableConfirmationModal]="true" [fromCard]="true"></app-make-bid>
                      </ng-container>
                      <ng-container *ngIf="vehicle.target == 'EXCLUSIVE_GROUPS' && vehicle.exclusiveDealer == false">
                        <app-exclusive-group-request [vehicle]="vehicle" [isListCard]="true"> </app-exclusive-group-request>
                      </ng-container>
                    </div>
                  </div>
                  <div *ngIf="vehicle.bidOption === 'NONE' || !user">
                    <span class="makebid-button btn btn-primary btn-rounded ml-1">Ver mais</span>
                  </div>
                </ng-container>
                <ng-container *ngIf="vehicle.ownsCurrentBid && !vehicle.sold && !ownsVehicle">
                  <i class="material-icons">check_circle</i> Você está arrematando
                </ng-container>
                <ng-container *ngIf="!hasPendingCounterOffer && !vehicle.ownsCurrentBid && !vehicle.sold && !ownsVehicle && !vehicle.hasBids && vehicle.hasPersonalizedOffer">
                  <i class="material-icons" *ngIf="vehicle.personalizedOfferStatus === 'REJECTED'">warning</i>
                  <span class="personalized-offer-warning">
                    {{ vehicle.personalizedOfferStatus === "REJECTED" ? "Oferta personalizada rejeitada" : "Oferta personalizada em análise" }}: R$
                    {{ vehicle.personalizedOfferValue | number }}</span
                  >
                </ng-container>
                <ng-container *ngIf="vehicle.sold && !vehicle.comissionPaid && vehicle.ownsCurrentBid && !hideSoldPurchaseInfo">
                  <i class="material-icons">warning</i> Fee plataforma pendente
                </ng-container>

                <app-auction-stats
                  [stats]="vehicle.status === 'FAST_QUOTE' ? vehicle.fastQuoteStats : vehicle.stats"
                  *ngIf="ownsVehicle && (vehicle.active || vehicle.status === 'FAST_QUOTE')"
                >
                </app-auction-stats>
              </div>
            </a>
            <div class="sold-at-info" *ngIf="vehicle.sold && (vehicle.comissionPaid || !vehicle.ownsCurrentBid)">
              em {{ vehicle.soldAt | date : "dd/MM/yyyy" }} às
              {{ vehicle.soldAt | date : "HH:mm" }}
            </div>

            <div class="deletion-description" *ngIf="vehicle.status === 'DELETED' && ownsVehicle">
              Veículo excluído em {{ vehicle.deletedAt | date : "dd/MM/yyyy" }}, às {{ vehicle.deletedAt | date : "HH:mm" }}.<br />
              <strong>Motivo:</strong> {{ getDeletionReasonLabel() }}
            </div>
          </div>
        </div>

        <div *ngIf="vehicle.hasConditionalOfferPending" class="label">
          <span>Condicional desde: {{ vehicle.expirationDate | date : "dd/MM/yyyy" }}</span>
        </div>

        <div class="row flex-grow-1 align-content-end">
          <div class="col-12">
            <!-- <div class="d-flex align-items-center" *ngIf="!vehicle.sold && vehicle.active">
              <div class="d-flex flex-grow-1">
                <div class="progress w-100" style="height: 8px">
                  <div
                    class="progress-bar"
                    [ngClass]="{ 'progress-bar-danger': contador?.danger }"
                    role="progressbar"
                    [style.width.%]="contador?.percentage"
                    [attr.aria-valuenow]="contador?.percentage"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
              <div class="d-flex justify-content-end">
                <div class="time" [ngClass]="{ 'time-danger': contador?.danger }">
                  <i class="material-icons">timer</i>
                  {{ contador?.days }}d {{ contador?.hours | number : "2.0-0" }}h {{ contador?.minutes | number : "2.0-0" }}m
                  {{ contador?.seconds | number : "2.0-0" }}s
                </div>
              </div>
            </div> -->
            <!-- <div class="infos">
              <div>
                <span><i class="material-icons">maps</i> {{ vehicle.km | number }} km</span>
                <span><i class="material-icons">label</i>{{ vehicle.numberPlate }}</span>
              </div>
              <div>
                <span *ngIf="vehicle.reportStatus"><i class="material-icons">playlist_add_check</i> {{ reportStatus }}</span>
                <span *ngIf="vehicle.extraKey !== undefined"
                  ><i class="material-icons">vpn_key</i> {{ vehicle.extraKey ? "Com chave reserva" : "Sem chave reserva" }}</span
                >
                <span *ngIf="vehicle.carManual !== undefined"
                  ><i class="material-icons">file_copy</i> {{ vehicle.carManual ? "Com manual" : "Sem manual" }}</span
                >
              </div>
              <div>
                <span><i class="material-icons">room</i> {{ vehicle.city }} / {{ vehicle.uf }}</span>
              </div>
            </div> -->
            <div class="d-flex" style="align-items: flex-end" *ngIf="(!vehicle.sold && vehicle.active && isDanger) || isCurrentBid && (user != undefined)">
              <div class="base-timer">
                <svg class="base-timer__svg" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                  <g class="base-timer__circle">
                    <circle class="base-timer__path-elapsed" cx="60" cy="60" r="50"></circle>
                    <path
                      class="base-timer__path-remaining"
                      [attr.stroke-dasharray]="contador?.circleDasharray"
                      [ngClass]="{ green: !contador?.danger, red: contador?.danger }"
                      d="
                      M 60, 60
                      m -50, 0
                      a 50,50 0 1,0 100,0
                      a 50,50 0 1,0 -100,0
                    "
                    ></path>
                  </g>
                </svg>
              </div>
              <div class="time" [ngClass]="{ 'time-danger': contador?.danger }">
                <i class="material-icons">timer</i>
                {{ contador?.days }}d {{ contador?.hours | number : "2.0-0" }}h {{ contador?.minutes | number : "2.0-0" }}m
                {{ contador?.seconds | number : "2.0-0" }}s
              </div>
            </div>
            <div class="oemDealer-info row flex-grow-1 align-items-center mt-2 mb-1">
              <div class="col-3">
                <div class="img-oemDealer">
                  <img [src]="vehicle.oemDealerImgUrl" />
                </div>
              </div>
              <div class="col-8">
                <div class="row">
                  <div class="col-12 oemDealer-name pt-1">
                    {{ vehicle.oemDealerName }}
                  </div>
                  <div class="col-12 localization my-2 ml-1" *ngIf="ownsVehicle">
                    <span>{{ vehicle.oemDealerLocation }}</span>
                  </div>
                  <div class="col-12 localization" *ngIf="vehicle.city || vehicle.uf">
                    <span>
                      <i class="material-icons" style="color: #cbced1">room</i>
                      <ng-container *ngIf="vehicle.city && vehicle.uf">{{ vehicle.city }} / {{ vehicle.uf }}</ng-container>
                      <ng-container *ngIf="vehicle.city && !vehicle.uf">{{ vehicle.city }}</ng-container>
                      <ng-container *ngIf="!vehicle.city && vehicle.uf">{{ vehicle.uf }}</ng-container>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
